import { searchFilterKeysMap } from '@rover/shared/js/search/utilities/searchFiltersMap';

/**
 * @description sets daycare type if applicable
 * @param searchParams URLSearchParams
 * @param inSittersHome boolean
 * @param atDaycareFacility boolean
 */
export const setDaycareType = (
  searchParams: URLSearchParams,
  inSittersHome?: boolean,
  atDaycareFacility?: boolean
): void => {
  if (inSittersHome) {
    searchParams.append(searchFilterKeysMap.daycareType, 'sitter');
  }
  if (atDaycareFacility) {
    searchParams.append(searchFilterKeysMap.daycareType, 'facility');
  }
};
